import React, { useMemo } from 'react'
import { formatCompactCurrency, formatCompactNumber } from '../../applications/Traffic/utils'

export interface SummaryCardProps {
  title: string
  value: number
  format: 'currency' | 'percentage' | 'roas' | 'number'
  subtitle?: string
  icon: React.ElementType
  color: string
  currency: string
}

export function SummaryCard({ title, value, format, subtitle, icon: Icon, color, currency }: SummaryCardProps) {
  const formattedValue = useMemo(() => {
    switch (format) {
      case 'currency': return formatCompactCurrency(value, currency)
      case 'percentage': return `${value.toFixed(1)}%`
      case 'roas': return `${value.toFixed(2)}x`
      default: return formatCompactNumber(value)
    }
  }, [value, format, currency])

  const colorClasses: Record<string, string> = {
    blue: 'tw-text-blue-600 tw-bg-blue-50',
    green: 'tw-text-green-600 tw-bg-green-50',
    orange: 'tw-text-orange-600 tw-bg-orange-50',
    purple: 'tw-text-purple-600 tw-bg-purple-50',
  }

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-p-4">
      <div className="tw-flex tw-items-start tw-justify-between">
        <div className={`tw-p-2 tw-rounded-lg ${colorClasses[color]}`}>
          <Icon className="tw-w-5 tw-h-5" />
        </div>
      </div>
      <div className="tw-mt-3">
        <p className="tw-text-sm tw-text-slate-600">{title}</p>
        <p className="tw-text-2xl tw-font-bold tw-text-slate-900">{formattedValue}</p>
        {subtitle != null && <p className="tw-text-sm tw-text-slate-500">{subtitle}</p>}
      </div>
    </div>
  )
}
